import { render, staticRenderFns } from "./Listagem-preparar-certificado.vue?vue&type=template&id=b9a9c7e6&"
import script from "./Listagem-preparar-certificado.vue?vue&type=script&lang=js&"
export * from "./Listagem-preparar-certificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports